// extracted by mini-css-extract-plugin
export default {"supportLink":"yIfRJKaExDlaXk1FUe_Q"};